import React from 'react'
import { Ico } from '@/components/icons'
import { useLang } from '@/lib/lang'

const ForgotPasswordView = () => {
  const { t } = useLang()
  const f = t.acct.auth.forgot
  const a = t.acct.auth.common

  return (
    <div style={{ height: "100%", background: "var(--paper)", display: "flex", alignItems: "center", justifyContent: "center", padding: 40 }}>
      <div style={{ width: 420 }}>
        <a href="#" className="font-mono" style={{ fontSize: 11, color: "var(--muted)", textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 6, marginBottom: 32 }}>
          {f.back_to_signin}
        </a>
        <h2 className="font-display" style={{ fontSize: 40, fontWeight: 600, letterSpacing: "-0.03em", margin: "0 0 12px", lineHeight: 1.05 }}>
          {f.title} <span className="font-serif" style={{ color: "var(--terracotta)", fontWeight: 400 }}>{f.title_word}</span>
        </h2>
        <p style={{ fontSize: 15, color: "var(--muted)", margin: "0 0 28px", lineHeight: 1.55 }}>
          {f.blurb}
        </p>

        <div style={{ marginBottom: 18 }}>
          <label className="auth-input-label">{a.email}</label>
          <input className="auth-input" defaultValue="maria@email.com"/>
        </div>

        <button className="btn btn-primary" style={{ width: "100%", justifyContent: "center", marginBottom: 14 }}>
          {f.send_link} <Ico.arrow/>
        </button>

        <div style={{ padding: 16, background: "var(--cream-2)", borderRadius: 12, display: "flex", gap: 12, alignItems: "start", fontSize: 13, color: "var(--muted)" }}>
          <div style={{ width: 32, height: 32, borderRadius: 8, background: "var(--paper)", color: "var(--cocoa)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}><Ico.phone/></div>
          <div>
            <div style={{ fontSize: 13, fontWeight: 600, color: "var(--cocoa)", marginBottom: 2 }}>Locked out?</div>
            <span>Call us at <a href="tel:3055551042" style={{ color: "var(--terracotta)" }}>(305) 555-1042</a>. We verify by phone in 30 seconds.</span>
          </div>
        </div>

        {/* Success state preview */}
        <div style={{ marginTop: 24, padding: 18, border: "1px dashed var(--line-strong)", borderRadius: 12 }}>
          <div className="font-mono" style={{ fontSize: 10, color: "var(--muted)", marginBottom: 8 }}>AFTER SUBMIT →</div>
          <div style={{ display: "flex", gap: 12, alignItems: "start" }}>
            <div style={{ width: 32, height: 32, borderRadius: "50%", background: "rgba(122,140,108,0.18)", color: "var(--sage)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}><Ico.check/></div>
            <div>
              <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 2 }}>Check your inbox</div>
              <div style={{ fontSize: 12, color: "var(--muted)", lineHeight: 1.5 }}>We sent a link to <strong>maria@email.com</strong>. Didn't get it? <a href="#" style={{ color: "var(--terracotta)" }}>Resend in 0:42</a></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default function ForgotPasswordPage() {
  return <ForgotPasswordView />
}
